export type TLitterPricing = {
  quantity: number | "default";
  discountSaving: number;
  unitPrice: number;
  discount?: {
    code: string;
    unit: number;
    unitType: "absoluteTotal" | "fixedAmount" | "percentage";
  };
};

export const PRICING_MATRIX: Record<number, TLitterPricing> = {
  1: {
    quantity: 1,
    discountSaving: 0,
    unitPrice: 18.0,
  },
  2: {
    quantity: 2,
    discountSaving: 10,
    unitPrice: 16.0,
  },
  3: {
    quantity: 3,
    discountSaving: 15,
    unitPrice: 15.0,
  },
  4: {
    quantity: 4,
    discountSaving: 20,
    unitPrice: 14.0,
  },
};

export const MAX_SAVING: TLitterPricing = {
  ...PRICING_MATRIX[4],
  quantity: "default",
};
